import React from 'react';
import { HTMLRenderer, Rating } from '@pelando/components';
import StoreDetailsSkeleton from './skeleton';

import {
  StoreDetailsContainer,
  StoreDetailsTitle,
  StoreDetailsRating,
  StoreDetailsRatingText,
  StoreDetailsTotalRating,
  StoreDetailsCollapse,
} from './style';
import { useTranslation } from '../../hooks/useTranslation';

export type StoreDetailsProps = {
  storeName: string;
  rating: number;
  ratingCount: number;
  shortDescription: string;
  loading?: boolean;
};

const StoreDetails = ({
  storeName,
  rating,
  ratingCount,
  shortDescription,
  loading,
}: StoreDetailsProps) => {
  const { t } = useTranslation('coupons');
  const ratingCountText =
    ratingCount === 1 ? t('rating-count-text') : t('rating-count-text-plural');

  if (loading) {
    return <StoreDetailsSkeleton />;
  }

  return (
    <StoreDetailsContainer>
      <StoreDetailsTitle>
        {t('about')} {storeName}
      </StoreDetailsTitle>
      <StoreDetailsRating>
        <StoreDetailsRatingText>{rating.toFixed(1)}</StoreDetailsRatingText>
        <Rating value={rating} />
        <StoreDetailsTotalRating>
          ({ratingCount} {ratingCountText})
        </StoreDetailsTotalRating>
      </StoreDetailsRating>
      <StoreDetailsCollapse
        closeCollapseText={t('close-collapse-text')}
        openCollapseText={t('open-collapse-text')}
      >
        <HTMLRenderer>{shortDescription}</HTMLRenderer>
      </StoreDetailsCollapse>
    </StoreDetailsContainer>
  );
};

export default StoreDetails;
